import {
  Input,
  Output,
  EventEmitter,
  Directive,
  OnDestroy,
  SimpleChanges,
  OnChanges,
  NgZone,
} from '@angular/core';
import { zip } from 'rxjs';
import { AmapHeatmapService, AMapHeatmap } from './amap-heatmap.service';
import { LoggerService } from '../../shared/logger/logger.service';
import { getOptions, ChangeFilter } from '../../utils';

const TAG = 'amap-heatmap';
const HeatmapOptions = ['radius', 'gradient', 'opacity', 'zooms'];

@Directive({
  selector: 'amap-heatmap',
  exportAs: 'heatmap',
  providers: [AmapHeatmapService],
})
export class AmapHeatmapDirective implements OnChanges, OnDestroy {
  // ---- Options ----
  /**
   * ç­åå¾ä¸­åä¸ªç¹çåå¾ï¼é»è®¤ï¼30ï¼åä½ï¼pixel
   */
  @Input() radius: number;
  /**
   * ç­åå¾çæ¸ååºé´
   */
  @Input() gradient: { [key: string]: string };
  /**
   * ç­åå¾éæåº¦æ°ç»ï¼åå¼èå´[0,1]ï¼0è¡¨ç¤ºå®å¨éæï¼1è¡¨ç¤ºä¸éæ
   * é»è®¤ï¼[0,1]
   */
  @Input() opacity: [number, number];
  /**
   * æ¯æçç¼©æ¾çº§å«èå´ï¼åå¼èå´[3-18]
   * é»è®¤ï¼[3,18]
   */
  @Input() zooms: [number, number];
  /**
   * é¢å¤: æ¯å¦éè
   */
  @Input() hidden = false;
  /**
   * é¢å¤: ä¼è¦çå¶ä»å±æ§çéç½®æ¹å¼
   */
  @Input() options: AMapHeatmap.Options;
  /**
   * é¢å¤: åæ æ°æ®é
   */
  @Input() dataset: AMapHeatmap.DataSet;

  // ---- Events ----
  @Output() naReady = new EventEmitter();

  private inited = false;

  constructor(
    protected os: AmapHeatmapService,
    private logger: LoggerService,
    private ngZone: NgZone,
  ) {}

  ngOnDestroy() {
    this.os.destroy();
  }

  ngOnChanges(changes: SimpleChanges) {
    const filter = ChangeFilter.of(changes);
    const heatmap = this.get();
    if (!this.inited) {
      this.logger.d(TAG, 'initializing ...');
      const options = this.options || getOptions<AMapHeatmap.Options>(this, HeatmapOptions);
      this.logger.d(TAG, 'options:', options);
      this.os.create(options).subscribe(m => {
        this.ngZone.run(() => this.naReady.emit(m));
        this.logger.d(TAG, 'heatmap is ready.');
      });
      this.inited = true;
    } else {
      zip(filter.has<AMapHeatmap.Options>('options'), heatmap).subscribe(([v, p]) =>
        p.setOptions(v || {}),
      );
    }

    zip(filter.notEmpty<AMapHeatmap.DataSet>('dataset'), heatmap).subscribe(([v, p]) => {
      p.setDataSet(v);
    });
    zip(filter.has<boolean>('hidden'), heatmap).subscribe(([v, p]) => (v ? p.hide() : p.show()));
  }

  /**
   * è·åå·²åå»ºç AMap.Heatmap å¯¹è±¡
   */
  get() {
    return this.os.get();
  }
}
